import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('../components/Login.vue'),
    },
    { path: '/', redirect: '/home' },
]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    // ---------- 首页 ----------
    home: {
        path: 'home',
        name: 'home',
        meta: { title: '首页' },
        component: () => import('../views/home/home.vue'),
    },

    // -----------交易管理----------------

    transactionMarket: { // 交易管理 销售订单列表
        path: 'transactionMarket',
        name: 'transactionMarket',
        meta: { title: '交易管理' },
        component: () => import('../views/transaction/market-order.vue'),
    },
    marketOrderdetail: { // 交易管理 销售订单列表
        path: 'marketOrderdetail',
        name: 'marketOrderdetail',
        meta: { title: '销售订单详情' },
        component: () => import('../views/transaction/market-order-detail.vue'),
    },
    transactionIntegral: { // 交易管理 积分订单
        path: 'transactionIntegral',
        name: 'transactionIntegral',
        meta: { title: '积分订单列表' },
        component: () => import('../views/transaction/Integral-order.vue'),
    },
    integralOrderdetail: { // 交易管理 积分订单详情
        path: 'integralOrderdetail',
        name: 'integralOrderdetail',
        meta: { title: '积分订单详情' },
        component: () => import('../views/transaction/integral-order-detail.vue'),
    },

    transactionAfter: { // 交易管理 售后订单
        path: 'transactionAfter',
        name: 'transactionAfter',
        meta: { title: '售后订单列表' },
        component: () => import('../views/transaction/after-order.vue'),
    },
    afterSaledetail: { // 交易管理 售后详情页
        path: 'afterSaledetail',
        name: 'afterSaledetail',
        meta: { title: '售后订单详情' },
        component: () => import('../views/transaction/after-sale-detail.vue'),
    },
    transactionVip: { // 交易管理 vip订单
        path: 'transactionVip',
        name: 'transactionVip',
        meta: { title: 'VIP订单' },
        component: () => import('../views/transaction/vip-order.vue'),
    },
    // -----------商品管理----------------
    commodityClassify: { // 商品分类
        path: 'commodityClassify',
        name: 'commodityClassify',
        meta: { title: '商品分类' },
        component: () => import('../views/commodity/commodity-classify.vue'),
    },
    secondClassify: {
        path: 'secondClassify',
        name: 'secondClassify',
        meta: { title: '二级分类查看' },
        component: () => import('../views/commodity/second-classify.vue'),
    },

    commodityMarket: { // 销售商品
        path: 'commodityMarket',
        name: 'commodityMarket',
        meta: { title: '销售商品' },
        component: () => import('../views/commodity/commodity-market.vue'),
    },
    commodityAdd: { // 添加商品页面
        path: 'commodityAdd',
        name: 'commodityAdd',
        meta: { title: '添加商品' },
        component: () => import('../views/commodity/commodity-addition.vue'),
    },
    commodityIntegral: { // 积分商品
        path: 'commodityIntegral',
        name: 'commodityIntegral',
        meta: { title: '积分商品' },
        component: () => import('../views/commodity/commodity-integral.vue'),
    },


    // -----------合伙人管理----------------
    partnerAccountadministration: { // 合伙人账号管理
        path: 'partnerAccountadministration',
        name: 'partnerAccountadministration',
        meta: { title: '合伙人账号管理' },
        component: () => import('../views/partner/partenr-account.vue'),
    },
    partnerIncomeadministration: { // 合伙人收益管理
        path: 'partnerIncomeadministration',
        name: 'partnerIncomeadministration',
        meta: { title: '合伙人收益管理' },
        component: () => import('../views/partner/partenr-income.vue'),
    },
    partnerVariableadministration: { // 合伙人收益管理
        path: 'partnerVariableadministration',
        name: 'partnerVariableadministration',
        meta: { title: '合伙人系统变量' },
        component: () => import('../views/partner/partenr-variable.vue'),
    },
    // -----------审核管理----------------
    auditAutonym: { // 用户实名认证
        path: 'auditAutonym',
        name: 'auditAutonym',
        meta: { title: '用户实名认证' },
        component: () => import('../views/audit/audit-autonym.vue'),
    },
    auditAlipay: { // 支付宝审核
        path: 'auditAlipay',
        name: 'auditAlipay',
        meta: { title: '支付宝审核' },
        component: () => import('../views/audit/audit-alipay.vue'),
    },
    auditBank: { // 银行卡审核
        path: 'auditBank',
        name: 'auditBank',
        meta: { title: '银行卡审核' },
        component: () => import('../views/audit/audit-bank.vue'),
    },
    auditPartner: { // 合伙人提现审核
        path: 'auditPartner',
        name: 'auditPartner',
        meta: { title: '合伙人申请' },
        component: () => import('../views/audit/audit-partner.vue'),
    },
    auditPartnerwithdraw: { // 合伙人提现审核
        path: 'auditPartnerwithdraw',
        name: 'auditPartnerwithdraw',
        meta: { title: '合伙人提现' },
        component: () => import('../views/audit/audit-partnerwithdraw.vue'),
    },
    auditWithdraw: { // 合伙人提现审核
        path: 'auditWithdraw',
        name: 'auditWithdraw',
        meta: { title: '提现申请' },
        component: () => import('../views/audit/audit-withdraw.vue'),
    },
    auditcashPartner: { // 合伙人保证金审核
        path: 'auditcashPartner',
        name: 'auditcashPartner',
        meta: { title: '合伙人缴纳保证金' },
        component: () => import('../views/audit/audit-cash.vue'),
    },
    auditcashextractPartner: { // 合伙人保证金审核
        path: 'auditcashextractPartner',
        name: 'auditcashextractPartner',
        meta: { title: '合伙人提取保证金' },
        component: () => import('../views/audit/audit-cashextract.vue'),
    },
    auditcashextractPartnerdetails: { // 合伙人保证金审核
        path: 'auditcashextractPartnerdetails',
        name: 'auditcashextractPartnerdetails',
        meta: { title: '合伙人提取保证金详情' },
        component: () => import('../views/audit/audit-cashextract-detail.vue'),
    },
    //--------------------
    partenrIncomeOrder: { //
        path: 'partenrIncomeOrder',
        name: 'partenrIncomeOrder',
        meta: { title: '合伙人收益-订单明细' },
        component: () => import('../views/partner/partenr-income-order.vue'),
    },
    partenrIncomeEarnings: { //
        path: 'partenrIncomeEarnings',
        name: 'partenrIncomeEarnings',
        meta: { title: '合伙人收益-收益明细' },
        component: () => import('../views/partner/partenr-income-earnings.vue'),
    },
    partenrIncomeDeposit: { //
        path: 'partenrIncomeDeposit',
        name: 'partenrIncomeDeposit',
        meta: { title: '合伙人收益-提现明细' },
        component: () => import('../views/partner/partenr-income-deposit.vue'),
    },







    // -----------活动设置管理----------------
    trochaldiskSet: { // 大轮盘设置
        path: 'trochaldiskSet',
        name: 'trochaldiskSet',
        meta: { title: '活动设置管理' },
        component: () => import('../views/activities-set/trochaldisk-set.vue'),
    },
    trochaldiskDetail: { // 大轮盘中奖明细
        path: 'trochaldiskDetail',
        name: 'trochaldiskDetail',
        meta: { title: '大轮盘中奖明细' },
        component: () => import('../views/activities-set/trochaldisk-detail.vue'),
    },
    conversionredSet: { // 兑换红包设置
        path: 'conversionredSet',
        name: 'conversionredSet',
        meta: { title: '兑换红包设置' },
        component: () => import('../views/activities-set/conversionred-set.vue'),
    },
    conversionredDetail: { // 兑换红包明细
        path: 'conversionredDetail',
        name: 'conversionredDetail',
        meta: { title: '兑换红包明细' },
        component: () => import('../views/activities-set/conversionred-detail.vue'),
    },
    everydayExplosive: { // 每日爆品
        path: 'everydayExplosive',
        name: 'everydayExplosive',
        meta: { title: '每日爆品' },
        component: () => import('../views/activities-set/everyday-explosive.vue'),
    },
    timelimitSeckill: { // 限时秒杀
        path: 'timelimitSeckill',
        name: 'timelimitSeckill',
        meta: { title: '限时秒杀' },
        component: () => import('../views/activities-set/timelimit-seckill.vue'),
    },
    // -----------营销中心----------------
    marketingShop: { // 门店轮播图
        path: 'marketingShop',
        name: 'marketingShop',
        meta: { title: '门店轮播图' },
        component: () => import('../views/marketing/marketing-shop.vue'),
    },
    marketingKongkim: { // 金刚区管理
        path: 'marketingKongkim',
        name: 'marketingKongkim',
        meta: { title: '营销中心' },
        component: () => import('../views/marketing/marketing-kongkim.vue'),
    },
    marketingFirstclassifi: { // 一级分类商品设置
        path: 'marketingFirstclassifi',
        name: 'marketingFirstclassifi',
        meta: { title: '一级分类商品设置' },
        component: () => import('../views/marketing/marketing-firstclassifi.vue'),
    },
    marketingSecondclassifi: { // 二级分类设置
        path: 'marketingSecondclassifi',
        name: 'marketingSecondclassifi',
        meta: { title: '二级分类设置' },
        component: () => import('../views/marketing/marketing-secondclassifi.vue'),
    },
    marketingSecondcommdityclassifi: { // 二级分类商品设置
        path: 'marketingSecondcommdityclassifi',
        name: 'marketingSecondcommdityclassifi',
        meta: { title: '二级分类商品设置' },
        component: () => import('../views/marketing/marketing-secondcommdityclassifi.vue.vue'),
    },
    // -----------供应商管理----------------
    supplierManagement: { // 供应商管理
        path: 'supplierManagement',
        name: 'supplierManagement',
        meta: { title: '供应商管理' },
        component: () => import('../views/supplier/supplier-management.vue'),
    },
    supplierFreightset: { // 供应商管理
        path: 'supplierFreightset',
        name: 'supplierFreightset',
        meta: { title: '运费模板设置' },
        component: () => import('../views/supplier/supplier-freight.vue'),
    },
    // -----------基础设置----------------
    help: { // 帮助中心
        path: 'help',
        name: 'help',
        meta: { title: '帮助中心' },
        component: () => import('../views/basic-setting/help.vue'),
    },
    search: { // 搜索设置
        path: 'search',
        name: 'search',
        meta: { title: '搜索设置' },
        component: () => import('../views/basic-setting/search.vue'),
    },
    agreement: { // 协议管理
        path: 'agreement',
        name: 'agreement',
        meta: { title: '协议管理' },
        component: () => import('../views/basic-setting/agreement.vue'),
    },
    about: { // 关于我们
        path: 'about',
        name: 'about',
        meta: { title: '关于我们' },
        component: () => import('../views/basic-setting/about.vue'),
    },
    about: { // 关于我们
        path: 'about',
        name: 'about',
        meta: { title: '帮助中心' },
        component: () => import('../views/basic-setting/about.vue'),
    },
    sensitive: { // 敏感词屏蔽
        path: 'sensitive',
        name: 'sensitive',
        meta: { title: '敏感词屏蔽' },
        component: () => import('../views/basic-setting/sensitive.vue'),
    },
    system: { // 系统通知
        path: 'system',
        name: 'system',
        meta: { title: '系统通知' },
        component: () => import('../views/basic-setting/system.vue'),
    },
    call: { // 联系我们
        path: 'call',
        name: 'call',
        meta: { title: '联系我们' },
        component: () => import('../views/basic-setting/call.vue'),
    },
    versions: { // 联系我们
        path: 'versions',
        name: 'versions',
        meta: { title: 'APP管理' },
        component: () => import('../views/basic-setting/versions.vue'),
    },

    // -----------用户管理----------------
    userExamine: { // 用户管理
        path: 'userExamine',
        name: 'userExamine',
        meta: { title: '用户查看' },
        component: () => import('../views/user/user-examine.vue'),
    },

    userDetails: { // 用户详情
        path: 'userDetails',
        name: 'userDetails',
        meta: { title: '用户详情' },
        component: () => import('../views/user/user-examineDetails.vue'),
    },
    userDataStatistics: { // 用户管理
        path: 'userDataStatistics',
        name: 'userDataStatistics',
        meta: { title: '用户数据统计' },
        component: () => import('../views/user/user-dataStatistics.vue'),
    },

    // -----------角色管理----------------
    roleManagement: { // 角色管理
        path: 'roleManagement',
        name: 'roleManagement',
        meta: { title: '角色管理' },
        component: () => import('../views/role/role-management.vue'),
    },
    roleAdd: { // 添加角色
        path: 'roleAdd',
        name: 'roleAdd',
        meta: { title: '添加角色' },
        component: () => import('../views/role/add-role.vue'),
    },
    roleAdministratorLog: { // 管理员日志
        path: 'roleAdministratorLog',
        name: 'roleAdministratorLog',
        meta: { title: '管理员日志' },
        component: () => import('../views/role/role-AdministratorLog.vue'),
    },
    // -----------  404页面  --------
    roleError: {
        path: 'roleError',
        name: 'roleError',
        meta: { title: '404错误' },
        component: () => import('../components/404.vue'),
    },

}

const createRouter = () => new Router({
    routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
